// extracted by mini-css-extract-plugin
module.exports = {"header":"featured-artists-module--header--3Tnz5","link":"featured-artists-module--link--3kKQo"};